'use client';

import type { RadioPropTypes } from './types';

import React from 'react';
import { useController } from 'react-hook-form';
import { Radio, RadioGroup as CkRadioGroup, Stack } from '@chakra-ui/react';

import { FormControl, FormErrorMessage } from '@/components';

const RadioGroup = React.forwardRef<HTMLInputElement, RadioPropTypes>(
  (
    {
      stackProps,
      optionProps,
      options,
      required,
      error,
      value,
      name,
      control,
      ...rest
    },
    forwardedRef
  ) => {
    const { field } = useController({
      name,
      control,
      defaultValue: value || '',
    });
    return (
      <FormControl isRequired={Boolean(required)} isInvalid={Boolean(error)}>
        <CkRadioGroup {...rest} {...field} ref={forwardedRef}>
          <Stack direction="row" {...stackProps}>
            {options.map((option) => (
              <Radio key={option.value} value={option.value} {...optionProps}>
                {option.label}
              </Radio>
            ))}
          </Stack>
        </CkRadioGroup>
        <FormErrorMessage message={error || ''} />
      </FormControl>
    );
  }
);

RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;
